<template>
    <div v-if="originalList && originalSpot && originalSpot.pivot.caption"
         class="map-post-comment original-caption"
         style="margin-top: 16px; text-align: left;" >

        <a :href="`/${originalList.user.username}`">
            <img :src="originalList.user.profile_thumbnail">
        </a>

        <!-- Form to Edit -->
        <div class="comment-content">
            <p class="full-comment">
                {{ (showingFullCaption || captionLength < 100) ? originalSpot.pivot.caption : strLimit(originalSpot.pivot.caption) }}
                <button v-if="captionLength > 100"
                        class="map-comment-shrink"
                        @click="toggleShowCaption()">
                    {{ showingFullCaption ? 'Less -' : 'More +'}}
                </button>
            </p>
        </div>

    </div>
</template>
<script>

import Helpers from '@/mixins/Helpers'

export default {

    mixins:[Helpers],

    props:['list', 'spot'],

    data(){
        return {
            captionLength : (this.spot.original && this.spot.original.pivot.caption) ? this.spot.original.pivot.caption.length : 0,
            showingFullCaption: false,
            originalList: this.list.original_list,
            originalSpot: this.spot.original,
        }
    },

    methods:{
        toggleShowCaption(){
            this.showingFullCaption = !this.showingFullCaption;
        },
    }
}
</script>
